import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelSelect as _vModelSelect, createBlock as _createBlock, withCtx as _withCtx } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("h4", null, "Dati task", -1);
const _hoisted_2 = { class: "form-group" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("label", null, "Prodotto (scala il credito)", -1);
const _hoisted_4 = { class: "d-flex justify-content-around" };
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
    key: 0,
    class: "fs-14 my-2"
};
const _hoisted_7 = /*#__PURE__*/ _createTextVNode("Il cliente ha acquistato anche: ");
const _hoisted_8 = { class: "fs-22 text-green" };
const _hoisted_9 = { class: "form-group" };
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("label", null, "Valore in crediti", -1);
const _hoisted_11 = { class: "form-group" };
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("label", null, "Nome task (es. indirizzo, tipo appartamento)", -1);
const _hoisted_13 = { class: "form-group" };
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("label", null, "Descrizione e note", -1);
const _hoisted_15 = [".value"];
const _hoisted_16 = { class: "row" };
const _hoisted_17 = { class: "form-group col-sm-6" };
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("label", null, "Data inizio", -1);
const _hoisted_19 = { class: "form-group col-sm-6" };
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("label", null, "Data consegna", -1);
const _hoisted_21 = { class: "form-group" };
const _hoisted_22 = /*#__PURE__*/ _createElementVNode("label", null, "Gestito da", -1);
const _hoisted_23 = /*#__PURE__*/ _createElementVNode("option", { value: null }, "Nessuno", -1);
const _hoisted_24 = ["value"];
const _hoisted_25 = { class: "row" };
const _hoisted_26 = { class: "form-group col-sm-3" };
const _hoisted_27 = /*#__PURE__*/ _createElementVNode("label", null, "Compenso", -1);
const _hoisted_28 = { class: "form-group col-sm-3" };
const _hoisted_29 = /*#__PURE__*/ _createElementVNode("label", null, "Priorità", -1);
const _hoisted_30 = { class: "form-group col-sm-3" };
const _hoisted_31 = /*#__PURE__*/ _createElementVNode("label", null, "Assegna a:", -1);
const _hoisted_32 = /*#__PURE__*/ _createElementVNode("option", { value: null }, "Nessuno", -1);
const _hoisted_33 = ["value"];
const _hoisted_34 = {
    key: 0,
    class: "form-group col-sm-3"
};
const _hoisted_35 = /*#__PURE__*/ _createElementVNode("label", null, "Data prima assegnazione", -1);
const _hoisted_36 = { class: "text-right mt-2" };
const _hoisted_37 = {
    key: 1,
    class: "btn btn-blue",
    type: "submit"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_op_date = _resolveComponent("op-date");
    const _component_mini_spinner = _resolveComponent("mini-spinner");
    const _component_val_form = _resolveComponent("val-form");
    const _directive_required = _resolveDirective("required");
    const _directive_number = _resolveDirective("number");
    return (_ctx.task)
        ? (_openBlock(), _createBlock(_component_val_form, {
            key: 0,
            onSubmit: _ctx.next,
            onInvalid: _ctx.warn
        }, {
            default: _withCtx(() => [
                _hoisted_1,
                _createElementVNode("div", _hoisted_2, [
                    _hoisted_3,
                    _createElementVNode("div", _hoisted_4, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (item, i) => {
                            return (_openBlock(), _createElementBlock("button", {
                                type: "button",
                                class: _normalizeClass(["btn btn-white", { active: _ctx.task.product.identifier == item.identifier }]),
                                key: i,
                                onClick: ($event) => (_ctx.setTaskProduct(item))
                            }, _toDisplayString(item.name), 11, _hoisted_5));
                        }), 128))
                    ]),
                    (_ctx.task.postOrderTask)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _hoisted_7,
                            _createElementVNode("b", _hoisted_8, _toDisplayString(_ctx.task.postOrderTask.name), 1)
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.task.creditPrice) = $event))
                    }, null, 512), [
                        [_vModelText, _ctx.task.creditPrice],
                        [_directive_required],
                        [_directive_number]
                    ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.task.title) = $event))
                    }, null, 512), [
                        [_vModelText, _ctx.task.title],
                        [_directive_required]
                    ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _withDirectives(_createElementVNode("textarea", {
                        class: "form-control",
                        rows: "3",
                        ".value": _ctx.task.description,
                        onInput: _cache[2] || (_cache[2] = ev => _ctx.task.description = ev.target.value),
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.task.description) = $event))
                    }, null, 40, _hoisted_15), [
                        [_vModelText, _ctx.task.description],
                        [_directive_required]
                    ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                        _hoisted_18,
                        _createVNode(_component_op_date, {
                            class: "form-control",
                            modelValue: _ctx.task.startDate,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.task.startDate) = $event))
                        }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                        _hoisted_20,
                        _createVNode(_component_op_date, {
                            class: "form-control",
                            modelValue: _ctx.task.dueDate,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.task.dueDate) = $event))
                        }, null, 8, ["modelValue"])
                    ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _withDirectives(_createElementVNode("select", {
                        class: "form-control",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.task.officeIdentifier) = $event))
                    }, [
                        _hoisted_23,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.offices, (item, i) => {
                            return (_openBlock(), _createElementBlock("option", {
                                value: item.identifier,
                                key: i
                            }, _toDisplayString(item.name), 9, _hoisted_24));
                        }), 128))
                    ], 512), [
                        [_vModelSelect, _ctx.task.officeIdentifier]
                    ])
                ]),
                _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                        _hoisted_27,
                        _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "form-control",
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.task.compenso) = $event))
                        }, null, 512), [
                            [_vModelText, _ctx.task.compenso],
                            [_directive_required],
                            [_directive_number]
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                        _hoisted_29,
                        _createElementVNode("div", null, [
                            _createElementVNode("button", {
                                type: "button",
                                class: _normalizeClass(["btn btn-checkbox", { 'checked': _ctx.task.priorita }]),
                                onClick: _cache[8] || (_cache[8] = ($event) => (_ctx.task.priorita = !_ctx.task.priorita))
                            }, null, 2)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                        _hoisted_31,
                        _withDirectives(_createElementVNode("select", {
                            class: "form-control",
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.userAssigned) = $event))
                        }, [
                            _hoisted_32,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.collaboratori, (item, i) => {
                                return (_openBlock(), _createElementBlock("option", {
                                    key: i,
                                    value: item
                                }, _toDisplayString(item.name), 9, _hoisted_33));
                            }), 128))
                        ], 512), [
                            [_vModelSelect, _ctx.userAssigned]
                        ])
                    ]),
                    (_ctx.userAssigned)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                            _hoisted_35,
                            _createVNode(_component_op_date, {
                                class: "form-control",
                                modelValue: _ctx.task.userAssigned.date,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_ctx.task.userAssigned.date) = $event))
                            }, null, 8, ["modelValue"])
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_36, [
                    (_ctx.saving)
                        ? (_openBlock(), _createBlock(_component_mini_spinner, { key: 0 }))
                        : (_openBlock(), _createElementBlock("button", _hoisted_37, " Salva "))
                ])
            ]),
            _: 1
        }, 8, ["onSubmit", "onInvalid"]))
        : _createCommentVNode("", true);
}
